const langDocumentType = {
	general_communication: {
		tag: 'document.type.general_communication',
		fr: 'Communications générales',
		en: 'General communication',
	},
	tax_legal_and_fund_rules: {
		tag: 'document.type.tax_legal_and_fund_rules',
		fr: 'Règlements (fonds, fiscals, légals)',
		en: 'Tax, Legal and fund rules',
	},
	subscriptions: {
		tag: 'document.type.subscriptions',
		fr: 'Contrats & souscriptions',
		en: 'Subscriptions',
	},
	periodic_report: {
		tag: 'document.type.periodic_report',
		fr: 'Rapports périodiques',
		en: 'Periodical reports',
	},
	certificate: {
		tag: 'document.type.certificate',
		fr: 'Attestations',
		en: 'Certificates',
	},
	annual_report: {
		tag: 'document.type.annual_report',
		fr: 'Rapports annuels',
		en: 'Annual reports',
	},
	monthly_report: {
		tag: 'document.type.monthly_report',
		fr: 'Rapports mensuels',
		en: 'Monthly reports',
	},
	ampere_report: {
		tag: 'document.type.ampere_report',
		fr: 'Rapports AMPERE',
		en: 'AMPERE Reports',
	},
	capital_call_and_distribution_notices: {
		tag: 'document.type.capital_call_and_distribution_notices',
		fr: 'Appels de fonds et distributions',
		en: 'Capital Call and Distribution notices',
	},
	consultation: {
		tag: 'document.type.consultation',
		fr: 'Consultation',
		en: 'Consultation',
	},
	capital_account_statement: {
		tag: 'document.type.capital_account_statement',
		fr: 'Relevé de compte de capital',
		en: 'Capital Account Statement',
	},
	esg_reports: {
		tag: 'document.type.esg_reports',
		fr: 'Rapports ESG',
		en: 'ESG reports',
	},
	mandate: {
		tag: 'document.type.mandate',
		fr: 'Mandat',
		en: 'Mandate',
	},
};

export default langDocumentType;
